(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
// Existing ProductModal and ProductRecommendations classes remain the same...
class ProductModal extends ModalDialog {
	constructor() {
		super();
		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

// window.shopifyMarkets is set by an inline script in the section markup
// (near the top of main-product.liquid, after the liquid assigns). Liquid
// is NOT rendered inside javascript section blocks — placing the assignment
// here shipped raw unrendered tags into compiled_assets/scripts.js and broke
// the entire bundle with a SyntaxError (task 1a, F1). The inline script runs
// at parse time; this bundle is deferred, so the data always exists first.

// Updated country detection function
function getCountryCode() {
  return window.shopifyMarkets.currentCountry.code;
}

function isSoutheastAsiaCountry() {
  return window.shopifyMarkets.isSoutheastAsia;
}

function isRestrictedProduct() {
  return window.shopifyMarkets.currentProduct.id.toString() === window.shopifyMarkets.restrictedProductId;
}

// Country-specific variant restrictions
const RESTRICTED_VARIANTS = {
  'AU': ['56134987252099', '56134993084803'] // Keep existing Australia restrictions for all products
};

const VARIANT_ID_TO_OPTION_MAP = {
  '56134987252099': '20 Boxes',
  '56134993084803': '30 Boxes'
};

// Function to check if variant should be hidden
function shouldHideVariant(variantId, country) {
  // For Southeast Asia, only apply to specific product (handled server-side)
  if (isSoutheastAsiaCountry() && isRestrictedProduct()) {
    return false; // Server-side handles this product completely
  }
  
  // Apply normal country restrictions to other products/countries
  const restrictedVariants = RESTRICTED_VARIANTS[country];
  return restrictedVariants && restrictedVariants.includes(variantId.toString());
}

// Function to hide restricted variants
function hideRestrictedVariants(country) {
  // For Southeast Asia on the restricted product, variants are hidden server-side
  if (isSoutheastAsiaCountry() && isRestrictedProduct()) {
    console.log(`🌏 Southeast Asia detected for restricted product ${window.shopifyMarkets.restrictedProductId} - all variants hidden server-side`);
    return;
  }
  
  // Continue with existing logic for other countries/products
  const restrictedVariants = RESTRICTED_VARIANTS[country];
  if (!restrictedVariants || restrictedVariants.length === 0) return;

  console.log(`🚫 Hiding variants for country ${country}:`, restrictedVariants);

  restrictedVariants.forEach(variantId => {
    // Method 1: Hide by variant ID
    const directVariantInputs = document.querySelectorAll(`input[value="${variantId}"]`);
    directVariantInputs.forEach(input => {
      const container = input.closest('.product-form__controls-group, .variant-option, .product-form__input, label') || input.parentElement;
      if (container) {
        container.style.display = 'none';
      }
      input.disabled = true;
    });

    // Method 2: Hide by option value
    const optionValue = VARIANT_ID_TO_OPTION_MAP[variantId];
    if (optionValue) {
      console.log(`🔍 Looking for option value: "${optionValue}" for variant ${variantId}`);
      
      const optionInputs = document.querySelectorAll(`input[type="radio"][value="${optionValue}"]`);
      optionInputs.forEach(input => {
        console.log(`🚫 Hiding input:`, input);
        
        input.style.display = 'none';
        input.disabled = true;
        
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (label) {
          console.log(`🚫 Hiding label:`, label);
          label.style.display = 'none';
        }
      });

      const labels = document.querySelectorAll('label.pills-variant-labels');
      labels.forEach(label => {
        if (label.textContent.trim().includes(optionValue)) {
          console.log(`🚫 Hiding label by text content:`, label);
          label.style.display = 'none';
          
          const inputId = label.getAttribute('for');
          if (inputId) {
            const correspondingInput = document.getElementById(inputId);
            if (correspondingInput) {
              correspondingInput.style.display = 'none';
              correspondingInput.disabled = true;
            }
          }
        }
      });
    }

    // Method 3: Hide select options
    const selectOptions = document.querySelectorAll(`option[value="${variantId}"]`);
    selectOptions.forEach(option => {
      option.style.display = 'none';
      option.disabled = true;
    });

    // Method 4: Hide variant buttons
    const variantButtons = document.querySelectorAll(`[data-variant-id="${variantId}"], [data-value="${variantId}"]`);
    variantButtons.forEach(button => {
      button.style.display = 'none';
      button.disabled = true;
    });
  });

  // Check if currently selected variant should be hidden and redirect to first available
  const currentVariantId = getCurrentVariantId();
  if (currentVariantId && shouldHideVariant(currentVariantId, country)) {
    console.log(`🔄 Current variant ${currentVariantId} is restricted for ${country}, switching to first available variant`);
    selectFirstAvailableVariant(country);
  }
}

// Enhanced function to detect current variant from option selection
function getCurrentVariantId() {
  // Method 1: Try URL parameter first
  const urlParams = new URLSearchParams(window.location.search);
  let variantId = urlParams.get('variant');
  
  if (!variantId) {
    // Method 2: Try product form hidden input
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
      }
    }
  }

  if (!variantId) {
    // Method 3: Try to derive from selected options
    const selectedOption = document.querySelector('input[type="radio"]:checked[name*="BUY MORE SAVE MORE"]');
    if (selectedOption) {
      const optionValue = selectedOption.value;
      // Look up variant ID from option value
      for (const [id, value] of Object.entries(VARIANT_ID_TO_OPTION_MAP)) {
        if (value === optionValue) {
          variantId = id;
          break;
        }
      }
    }
  }
  
  return variantId;
}

// Select first available (non-restricted) variant
function selectFirstAvailableVariant(country) {
  // Get all available radio options
  const radioOptions = document.querySelectorAll('input[type="radio"][name*="BUY MORE SAVE MORE"]:not([disabled])');
  
  for (const radio of radioOptions) {
    const optionValue = radio.value;
    
    // Check if this option corresponds to a restricted variant
    let isRestricted = false;
    for (const [variantId, mappedValue] of Object.entries(VARIANT_ID_TO_OPTION_MAP)) {
      if (mappedValue === optionValue && shouldHideVariant(variantId, country)) {
        isRestricted = true;
        break;
      }
    }
    
    // If not restricted and visible, select it
    if (!isRestricted && radio.style.display !== 'none') {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      console.log(`✅ Switched to available option: ${optionValue}`);
      break;
    }
  }
}

// Updated logging function
function logVariantAndCountry(variant = null) {
  const country = getCountryCode();
  const isSEA = isSoutheastAsiaCountry();
  const isRestricted = isRestrictedProduct();
  
  if (!variant && !(isSEA && isRestricted)) { // Only try to detect variant for non-restricted cases
    const variantId = getCurrentVariantId();
    if (variantId) {
      variant = {
        id: variantId,
        source: 'Auto-detected'
      };
    }
  }
  
  let variantDetails = {};
  if (variant && variant.id && !(isSEA && isRestricted)) {
    if (typeof window.product !== 'undefined' && window.product.variants) {
      const variantData = window.product.variants.find(v => v.id.toString() === variant.id.toString());
      if (variantData) {
        variantDetails = {
          title: variantData.title,
          price: variantData.price,
          available: variantData.available,
          sku: variantData.sku,
          options: variantData.options
        };
      }
    }
  }
  
  const variantIsRestricted = variant && shouldHideVariant(variant.id, country);
  
  console.group('🛍️ Product Variant & Country Information');
  console.log('🌍 Country:', country);
  console.log('🌏 Is Southeast Asia:', isSEA);
  console.log('🏷️ Product ID:', window.shopifyMarkets.currentProduct.id);
  console.log('🎯 Is Restricted Product:', isRestricted);
  
  if (isSEA && isRestricted) {
    console.log('🚫 All variants hidden for Southeast Asia on restricted product - Coming Soon mode');
  } else {
    console.log('🏷️ Variant ID:', variant ? variant.id : 'No variant selected');
    
    if (variantIsRestricted) {
      console.log('🚫 Variant Status: RESTRICTED for this country');
    }
    
    if (variant && variant.source) {
      console.log('📍 Variant Source:', variant.source);
    }
    
    if (Object.keys(variantDetails).length > 0) {
      console.log('📋 Variant Details:', variantDetails);
    }
  }
  
  console.log('⏰ Timestamp:', new Date().toISOString());
  console.groupEnd();
  
  return {
    country: country,
    isSoutheastAsia: isSEA,
    isRestrictedProduct: isRestricted,
    productId: window.shopifyMarkets.currentProduct.id,
    variant: (isSEA && isRestricted) ? null : variant,
    variantDetails: (isSEA && isRestricted) ? {} : variantDetails,
    isRestricted: (isSEA && isRestricted) ? true : variantIsRestricted,
    timestamp: new Date().toISOString()
  };
}

// Variant Change Detection
function setupVariantChangeLogging() {
  // Method 1: Listen for variant selector changes (dropdowns and buttons)
  document.addEventListener('change', function(e) {
    if (e.target.matches('select[name*="option"], input[name*="option"]')) {
      setTimeout(() => {
        const data = logVariantAndCountry();
        console.log('🔄 Variant changed via option selector');
      }, 100); // Small delay to ensure variant is updated
    }
  });
  
  // Method 2: Listen for variant button clicks
  document.addEventListener('click', function(e) {
    if (e.target.matches('input[type="radio"][name*="option"], .variant-option, [data-variant-id]')) {
      setTimeout(() => {
        const data = logVariantAndCountry();
        console.log('🔄 Variant changed via button click');
      }, 100);
    }
  });
  
  // Method 3: Monitor URL changes for variant parameter
  let currentVariantId = new URLSearchParams(window.location.search).get('variant');
  
  function checkForVariantChange() {
    const newVariantId = new URLSearchParams(window.location.search).get('variant');
    if (newVariantId !== currentVariantId) {
      currentVariantId = newVariantId;
      const data = logVariantAndCountry();
      console.log('🔄 Variant changed via URL update');
    }
  }
  
  // Check for URL changes periodically
  setInterval(checkForVariantChange, 1000);
  
  // Method 4: Listen for popstate events (back/forward navigation)
  window.addEventListener('popstate', function() {
    setTimeout(() => {
      const data = logVariantAndCountry();
      console.log('🔄 Variant changed via browser navigation');
    }, 100);
  });
}

// Initialize logging when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 Initializing variant and country logging...');
  
  const country = getCountryCode();
  const isSEA = isSoutheastAsiaCountry();
  const isRestricted = isRestrictedProduct();
  
  console.log('🌍 Detected country:', country);
  console.log('🌏 Is Southeast Asia:', isSEA);
  console.log('🎯 Is Restricted Product:', isRestricted);
  console.log('🏷️ Product ID:', window.shopifyMarkets.currentProduct.id);
  
  if (isSEA && isRestricted) {
    console.log('🌏 Southeast Asia detected on restricted product - variants hidden, showing Coming Soon');
  } else {
    // Hide restricted variants for other cases
    setTimeout(() => {
      hideRestrictedVariants(country);
    }, 100);
  }
  
  // Log initial state
  setTimeout(() => {
    logVariantAndCountry();
    console.log('📍 Initial page load logging complete');
  }, 500);
  
  // Set up change detection (only for non-restricted cases)
  if (!(isSEA && isRestricted)) {
    setupVariantChangeLogging();
  }
  
  // Existing overlay swipe indicators code...
  const overlayIndicators = document.querySelector('.swiper-overlay-indicators');
  const prevArrow = document.querySelector('.swiper-overlay-prev');
  const nextArrow = document.querySelector('.swiper-overlay-next');
  const dots = document.querySelectorAll('.swiper-overlay-dot');
  const slides = document.querySelectorAll('.js-media-list .swiper-slide');
  
  // Get existing swiper buttons
  const existingPrevBtn = document.querySelector('.swiper-btn--prev');
  const existingNextBtn = document.querySelector('.swiper-btn--next');
  
  if (!overlayIndicators || !slides.length) return;
  
  let currentSlide = 0;
  const totalSlides = slides.length;
  
  // Hide if only one image
  if (totalSlides <= 1) {
    overlayIndicators.style.display = 'none';
    return;
  }
  
  // Update dots
  function updateDots() {
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentSlide);
    });
  }
  
  // Get current slide from transform - FIXED VERSION
  function getCurrentSlideFromTransform() {
    const swiperWrapper = document.querySelector('.js-media-list .swiper-wrapper');
    if (!swiperWrapper) return 0;
    
    const transform = swiperWrapper.style.transform;
    if (!transform || transform === 'none') return 0;
    
    // Extract translateX value
    const translateMatch = transform.match(/translateX\((-?\d+(?:\.\d+)?)(%|px)\)/);
    if (translateMatch) {
      const value = parseFloat(translateMatch[1]);
      if (translateMatch[2] === '%') {
        // Percentage-based transform
        return Math.abs(Math.round(value / 100));
      } else {
        // Pixel-based transform (less common for swiper)
        const slideWidth = swiperWrapper.offsetWidth / totalSlides;
        return Math.abs(Math.round(value / slideWidth));
      }
    }
    
    return 0;
  }
  
  // Simply trigger existing buttons and update our indicators
  prevArrow?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (existingPrevBtn) {
      existingPrevBtn.click();
      
      // Update currentSlide after a short delay to let swiper finish
      setTimeout(() => {
        currentSlide = getCurrentSlideFromTransform();
        updateDots();
      }, 50);
    }
  });
  
  nextArrow?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (existingNextBtn) {
      existingNextBtn.click();
      
      // Update currentSlide after a short delay to let swiper finish
      setTimeout(() => {
        currentSlide = getCurrentSlideFromTransform();
        updateDots();
      }, 50);
    }
  });
  
  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Calculate direction and click appropriate button
      const targetSlide = index;
      let clicksNeeded = 0;
      let direction = '';
      
      if (targetSlide > currentSlide) {
        // Go forward
        clicksNeeded = targetSlide - currentSlide;
        direction = 'next';
      } else if (targetSlide < currentSlide) {
        // Go backward
        clicksNeeded = currentSlide - targetSlide;
        direction = 'prev';
      }
      
      // Perform the clicks with small delays
      let clickCount = 0;
      const performClicks = () => {
        if (clickCount < clicksNeeded) {
          if (direction === 'next' && existingNextBtn) {
            existingNextBtn.click();
          } else if (direction === 'prev' && existingPrevBtn) {
            existingPrevBtn.click();
          }
          clickCount++;
          setTimeout(performClicks, 100); // Small delay between clicks
        } else {
          // Update after all clicks are done
          setTimeout(() => {
            currentSlide = targetSlide;
            updateDots();
          }, 100);
        }
      };
      
      if (clicksNeeded > 0) {
        performClicks();
      }
    });
  });
  
  // Listen for manual swipes/existing button clicks - IMPROVED VERSION
  const swiperWrapper = document.querySelector('.js-media-list .swiper-wrapper');
  if (swiperWrapper) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const newSlide = getCurrentSlideFromTransform();
          if (newSlide !== currentSlide && newSlide >= 0 && newSlide < totalSlides) {
            currentSlide = newSlide;
            updateDots();
          }
        }
      });
    });
    
    observer.observe(swiperWrapper, {
      attributes: true,
      attributeFilter: ['style']
    });
  }
  
  // Also listen for swipe events on the container
  let startX = 0;
  let endX = 0;
  
  const swiperContainer = document.querySelector('.js-media-list');
  if (swiperContainer) {
    swiperContainer.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    swiperContainer.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      const threshold = 50;
      
      if (Math.abs(diff) > threshold) {
        // Wait for swiper to finish, then update
        setTimeout(() => {
          currentSlide = getCurrentSlideFromTransform();
          updateDots();
        }, 300);
      }
    }, { passive: true });
  }
  
  // Initialize
  setTimeout(() => {
    currentSlide = getCurrentSlideFromTransform();
    updateDots();
  }, 100);
});

// Enhanced Manual logging function with country override
window.logProductInfo = function(countryOverride = null) {
  const country = countryOverride || getCountryCode();
  console.log('🔍 Manual logging triggered for country:', country);
  return logVariantAndCountry();
};

// Manual function to hide variants for specific country
window.hideVariantsForCountry = function(country = null) {
  const targetCountry = country || getCountryCode();
  console.log('🚫 Manual variant hiding triggered for country:', targetCountry);
  hideRestrictedVariants(targetCountry);
};

// Function to check if specific variant is restricted
window.isVariantRestricted = function(variantId, country = null) {
  const targetCountry = country || getCountryCode();
  return shouldHideVariant(variantId, targetCountry);
};

// Force specific variants out of stock
const FORCE_OOS_VARIANTS = ['55161181307267', '55161175638403'];

function updateOOSButtonState() {
  const submitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!submitBtn) return;
  
  const currentVariantId = getCurrentVariantId();
  if (!currentVariantId) return;
  
  const isOOS = FORCE_OOS_VARIANTS.includes(currentVariantId.toString());
  const span = submitBtn.querySelector('span');
  
  if (isOOS) {
    submitBtn.disabled = true;
    submitBtn.classList.add('button--sold-out');
    if (span) span.textContent = 'SOLD OUT';
    
    const dynamicCheckout = document.querySelector('.product-form__checkout');
    if (dynamicCheckout) dynamicCheckout.style.display = 'none';
  } else {
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = productForm?.querySelector('input[name="id"]');
    if (variantInput && !variantInput.disabled) {
      submitBtn.disabled = false;
      submitBtn.classList.remove('button--sold-out');
      if (span) span.textContent = 'Add to cart';
      
      const dynamicCheckout = document.querySelector('.product-form__checkout');
      if (dynamicCheckout) dynamicCheckout.style.display = '';
    }
  }
}

document.addEventListener('change', function(e) {
  if (e.target.matches('select[name*="option"], input[name*="option"], input[type="radio"]')) {
    setTimeout(updateOOSButtonState, 150);
  }
});

document.addEventListener('click', function(e) {
  if (e.target.matches('input[type="radio"], .variant-option, [data-variant-id], label[for*="option"]')) {
    setTimeout(updateOOSButtonState, 150);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(updateOOSButtonState, 600);
});

let lastCheckedVariant = null;
setInterval(() => {
  const current = getCurrentVariantId();
  if (current !== lastCheckedVariant) {
    lastCheckedVariant = current;
    updateOOSButtonState();
  }
}, 500);

// Register custom elements
customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
